// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"8fed9f4b","453":"4db5424f","697":"fec10795"}[chunkId] + ".chunk.js";
};